<template>
  <v-menu
    v-if="sector"
    open-on-hover
    bottom
    offset-y
    :open-delay="200"
    :close-delay="120"
    :close-on-content-click="false"
    content-class="doorphone-mto-sector-cell__menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
        class="doorphone-mto-sector-cell__name"
        @click.stop
      >
        {{ sector.name }}
      </span>
    </template>

    <v-card class="doorphone-mto-sector-cell__card" flat>
      <div class="doorphone-mto-sector-cell__header">
        <v-icon small color="primary" class="doorphone-mto-sector-cell__header-icon">
          mdi-map-marker-radius
        </v-icon>
        <div class="doorphone-mto-sector-cell__header-text">
          <div class="doorphone-mto-sector-cell__title">{{ sector.name }}</div>
          <div class="doorphone-mto-sector-cell__id">ID {{ sector.id }}</div>
        </div>
      </div>

      <v-divider class="doorphone-mto-sector-cell__divider" />

      <div class="doorphone-mto-sector-cell__body">
        <div v-if="sector.service_area_name" class="doorphone-mto-sector-cell__row">
          <div class="doorphone-mto-sector-cell__row-label">Район обслуживания</div>
          <div class="doorphone-mto-sector-cell__row-value">{{ sector.service_area_name }}</div>
        </div>

        <div class="doorphone-mto-sector-cell__row">
          <div class="doorphone-mto-sector-cell__row-label">Мастер</div>
          <div v-if="master" class="doorphone-mto-sector-cell__masters">
            <router-link
              :to="`/user/${master.id}/edit`"
              class="doorphone-mto-sector-cell__user"
              @click.native.stop
            >
              <v-icon x-small class="doorphone-mto-sector-cell__user-icon">mdi-account-outline</v-icon>
              {{ master.name }}
            </router-link>
          </div>
          <div v-else class="doorphone-mto-sector-cell__empty">Не назначен</div>
        </div>
      </div>

      <template v-if="canOpenSector">
        <v-divider class="doorphone-mto-sector-cell__divider" />
        <div class="doorphone-mto-sector-cell__footer">
          <v-btn
            small
            text
            color="primary"
            class="text-none px-2"
            :to="`/mto-sector/${sector.id}`"
            @click.native.stop
          >
            Открыть участок
            <v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </template>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'DoorphoneMtoSectorCell',
  props: {
    sector: {
      type: Object,
      default: null,
    },
  },
  computed: {
    master () {
      return this.sector?.master || this.sector?.masters?.[0] || null;
    },
    canOpenSector () {
      return this.$canRoute('MtoSectorDetail');
    },
  },
};
</script>

<style lang="scss" scoped>
.doorphone-mto-sector-cell__name {
  color: #263238;
  cursor: pointer;
  text-decoration: none;
}

.doorphone-mto-sector-cell__name:hover {
  text-decoration: underline;
}

.doorphone-mto-sector-cell__card {
  width: 280px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.doorphone-mto-sector-cell__header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px 10px;
  background: #f5f8fa;
}

.doorphone-mto-sector-cell__header-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.doorphone-mto-sector-cell__header-text {
  min-width: 0;
}

.doorphone-mto-sector-cell__title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #263238;
  line-height: 1.35;
  word-break: break-word;
}

.doorphone-mto-sector-cell__id {
  font-size: 0.75rem;
  color: #78909c;
  margin-top: 2px;
}

.doorphone-mto-sector-cell__divider {
  border-color: rgba(0, 0, 0, 0.06);
}

.doorphone-mto-sector-cell__body {
  padding: 10px 14px 12px;
}

.doorphone-mto-sector-cell__row + .doorphone-mto-sector-cell__row {
  margin-top: 10px;
}

.doorphone-mto-sector-cell__row-label {
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #78909c;
  margin-bottom: 4px;
}

.doorphone-mto-sector-cell__row-value {
  font-size: 0.875rem;
  color: #37474f;
  line-height: 1.45;
  word-break: break-word;
}

.doorphone-mto-sector-cell__masters {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.doorphone-mto-sector-cell__user {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #1976d2;
  text-decoration: none;
  font-size: 0.875rem;
  line-height: 1.4;
}

.doorphone-mto-sector-cell__user:hover {
  text-decoration: underline;
}

.doorphone-mto-sector-cell__user-icon {
  color: #90a4ae;
}

.doorphone-mto-sector-cell__empty {
  font-size: 0.875rem;
  color: #90a4ae;
}

.doorphone-mto-sector-cell__footer {
  padding: 4px 8px 8px;
}
</style>

<style lang="scss">
.doorphone-mto-sector-cell__menu {
  contain: layout;
}
</style>
